import axios from 'axios';

const api = axios.create({
  // baseURL: 'http://127.0.0.1:8000/api', // رابط الباك إند
  // baseURL: 'http://localhost:8000/api', // رابط الباك إند
  baseURL: 'https://apicontrol.sinai-edu.com/api', // رابط الباك إند
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

export default api;
